import { track } from "../track";

export const trackSignUpFail = (params: {
  email: string;
  name?: string;
  quiz_id?: string;
}) => track({ event: "sign_up_fail", ...params });
